import Grid from '@telesoft/ui/components/grid';
import Button from '@telesoft/ui/components/ui/button';
import Text from '@telesoft/ui/components/ui/text';
import Link from 'next/link';
import Image from "next/image";
import React, { ReactElement } from 'react';
import Container from '@telesoft/ui/components/ui/container';

interface Props {}

export default function CallToActionNucleus({}: Props): ReactElement {
  return (
    <Container>
      <div className="relative bg-accent-1 p-8 md:p-12 lg:p-20 flex flex-col justify-center items-center">
        <Image
          src="/assets/images/telesoft-abstract-29.jpeg"
          className="object-cover object-center opacity-25"
          layout="fill"
        />
        <Grid className="gap-8 z-10">
          <div className="col-span-4">
            <Text variant="subHeading" className="">
              Resources Hub
            </Text>
          </div>

          <div className="col-span-4 pt-2 pb-4 lg:pb-0 border-b border-heading">
            <Text variant="body" className="text-black">
              The latest industry news, threats, advice and information from our
              network and cyber security specialists.
            </Text>
          </div>

          <div className="col-span-4 flex items-end">
            <Link href="/blog" legacyBehavior>
              <Button className="w-full" variant="flat">
                Take me to Resources
              </Button>
            </Link>
          </div>
        </Grid>
      </div>
    </Container>
  );
}
